import { BlipPaymentsFeatures } from './BlipPaymentsFeatures';
import { blipPaymentsSettingsSource, blipDomainUrl, blipWebsocketHostName, blipWebsocketHostNameTenant, messaginghubWebsocketHostNameTenant, messaginghubWebsocketHostName, } from 'app.constants';
import { Contexts, } from 'modules/core/ContextProcessorService';
import { MessagingHubFeatures } from 'modules/messaginghub/MessagingHubFeatures';
import { CrossAppFeatures } from 'modules/shared/featureToggle/CrossAppFeatures';
import { FeatureToggleClientService } from 'feature-toggle-client/dist/FeatureToggleClientService';
export class BlipPaymentsController {
    static $inject = ['LoadingService', 'AccountService2', 'ContextProcessorService', 'TranslateService', 'AuthenticationService', 'ApplicationService2', 'BuilderService'];
    constructor(LoadingService, AccountService2, ContextProcessorService, TranslateService, AuthenticationService, ApplicationService2, BuilderService) {
        this.LoadingService = LoadingService;
        this.AccountService2 = AccountService2;
        this.ContextProcessorService = ContextProcessorService;
        this.TranslateService = TranslateService;
        this.AuthenticationService = AuthenticationService;
        this.ApplicationService2 = ApplicationService2;
        this.BuilderService = BuilderService;
        this.blipDomainUrl = blipDomainUrl;
        this.blipWebsocketHostName = messaginghubWebsocketHostName;
        this.blipWebsocketHostNameTenant = messaginghubWebsocketHostNameTenant;
        this.IsBlipPaymentsEnabled = false;
        this.blipClusterUrl = blipDomainUrl;
        this.readyToRender = false;
        this.checkTenantContext = async (ContextProcessorService) => {
            await ContextProcessorService.waitForInitialization();
            this.isOnTenantContext =
                this.ContextProcessorService.context === Contexts.Tenants;
        };
        this.checkTenantID = async (ContextProcessorService) => {
            await ContextProcessorService.waitForInitialization();
            this.isOnTenantID =
                this.ContextProcessorService.tenant.id !== null
                    ? this.ContextProcessorService.tenant.id
                    : '';
        };
    }
    async $onInit() {
        const useDelegation = await MessagingHubFeatures.GetMessagingHubCommandWithDelegation();
        this.user = this.AccountService2.meSync();
        this.language = this.TranslateService.getCurrentLanguage();
        this.authToken = this.AuthenticationService.token;
        this.authEmail = this.AuthenticationService.email;
        this.featureFlags = FeatureToggleClientService.getInstance()
            .getUserInstance()
            .allFlags();
        this.cluster = this.blipClusterUrl
            .replace('https://', '')
            .split('.')[0];
        this.account = await this.AccountService2.me();
        this.blipWebsocketHostName = useDelegation
            ? blipWebsocketHostName
            : messaginghubWebsocketHostName;
        this.blipWebsocketHostNameTenant = useDelegation
            ? blipWebsocketHostNameTenant
            : messaginghubWebsocketHostNameTenant;
        this.authEmail = this.AuthenticationService.email;
        this.readyToRender = true;
        this.checkTenantID(this.ContextProcessorService);
        this.settingsSource = blipPaymentsSettingsSource;
        this.webSocketParams = {
            blipDomainUrl,
            blipWebsocketHostName,
            blipWebsocketHostNameTenant,
        };
        await this.checkFeatures();
        this.LoadingService.stopLoading();
    }
    async checkFeatures() {
        this.IsBlipPaymentsEnabled =
            await BlipPaymentsFeatures.IsBlipPaymentsEnabled();
        this.useFooterWithBlipStatus =
            await CrossAppFeatures.useFooterWithBlipStatus();
    }
}
